import Tabs from './tabs';
import PersistedTabs from './persisted';
import ControlledTabs from './controlled';
export { Tabs, PersistedTabs, ControlledTabs };